import { OktaAuth } from '@okta/okta-auth-js';

// Get Okta configuration from environment variables
const CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID || '0oak3tcaum5XqLv2J1d7';
const ISSUER = process.env.REACT_APP_OKTA_ISSUER || 'https://fctg.oktapreview.com/oauth2/default';
// Ensure the issuer has a trailing slash
const normalizedIssuer = ISSUER.endsWith('/') ? ISSUER : `${ISSUER}/`;

// Create the OktaAuth instance
const oktaAuth = new OktaAuth({
  issuer: normalizedIssuer,
  clientId: CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  useInteractionCodeFlow: false,
  responseType: ['code'],
  tokenManager: {
    storage: 'localStorage'
  },
  cookies: {
    secure: process.env.NODE_ENV !== 'development',
    sameSite: 'lax'
  },
  disableHttpsCheck: process.env.NODE_ENV === 'development',
});

// Subscribe to auth state changes using the authStateManager
oktaAuth.authStateManager.subscribe(authState => {
  console.log('Auth State Changed:', authState);
  
  if (authState.error) {
    console.error('Okta Error:', authState.error);
  }
});

// Configure the token service for better error logging
oktaAuth.tokenManager.on('error', (error) => {
  console.error('TokenManager Error:', error);
});

// Log the configuration for debugging in development environment
if (process.env.NODE_ENV === 'development') {
  console.log('Okta Config:', {
    clientId: CLIENT_ID ? '****' : 'not set', // Hide actual ID in logs
    issuer: normalizedIssuer || 'not set',
    redirectUri: window.location.origin + '/login/callback',
    postLogoutRedirectUri: window.location.origin,
    pkce: true,
  });
}

export default oktaAuth;